import * as React from 'react';
import LoadingIndicator from './LoadingIndicator';

const SelectorMenuLoading: React.FC<{}> = (props) => {
  return (
    <div className="csm-selector-menu-loading">
      <LoadingIndicator label="Loading" size="small" textPosition="bottom" />
    </div>
  );
};

export default SelectorMenuLoading;
